import type { TypePolicies } from '../../../../../utils/types/TypePolicies';
import { assetDetailsPanelStateMap } from '../state';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      assetDetailsPanelState: (_, { variables }) => {
        const input = (
          variables as { input?: { userId?: string; resourceId?: string } }
        )?.input;
        return assetDetailsPanelStateMap.get(
          `${input?.userId}-${input?.resourceId}`
        );
      },
    },
  },
};
